import { render, staticRenderFns } from "./List_Manage.vue?vue&type=template&id=5b59a02c"
import script from "./List_Manage.vue?vue&type=script&lang=js"
export * from "./List_Manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports